import { useVercount } from '../hooks/useVercount'
import { cn } from '../lib/utils'

interface VercountProps {
  className?: string
  /** compact: 一行小字；detail: 三列卡片式 */
  variant?: 'compact' | 'detail'
}

export function Vercount({ className, variant = 'compact' }: VercountProps) {
  const { sitePv, pagePv, siteUv } = useVercount()

  if (variant === 'detail') {
    return (
      <div
        className={cn(
          'grid grid-cols-3 gap-2 text-center',
          className,
        )}
        aria-label="访问统计"
      >
        <Stat label="本页阅读" value={pagePv} />
        <Stat label="本站访问" value={sitePv} />
        <Stat label="本站访客" value={siteUv} />
      </div>
    )
  }

  return (
    <p
      className={cn(
        'text-[11px] text-muted-foreground tabular-nums leading-relaxed',
        className,
      )}
      aria-label="访问统计"
    >
      本页 <span className="font-medium text-foreground/80">{pagePv}</span>
      <span className="mx-1.5 text-border">·</span>
      总访问 <span className="font-medium text-foreground/80">{sitePv}</span>
      <span className="mx-1.5 text-border">·</span>
      访客 <span className="font-medium text-foreground/80">{siteUv}</span>
    </p>
  )
}

function Stat({ label, value }: { label: string; value: string }) {
  return (
    <div className="rounded-xl bg-secondary/60 px-2 py-3">
      <p className="text-[11px] text-muted-foreground mb-1">{label}</p>
      <p className="text-base font-semibold tabular-nums tracking-tight">{value}</p>
    </div>
  )
}
